import React from 'react';
import { JournalText, QuestionCircle, Lightbulb, FileEarmarkText } from 'react-bootstrap-icons';

const SUGGESTIONS = [
  {
    icon: JournalText,
    title: 'Lesson plan',
    prompt:
      'Help me create a 45-minute lesson plan on photosynthesis for 8th grade students, with learning objectives, activities, and a short assessment.',
  },
  {
    icon: QuestionCircle,
    title: 'Quiz questions',
    prompt:
      'Generate 8 mixed-difficulty quiz questions on the American Revolution with answers and brief explanations.',
  },
  {
    icon: Lightbulb,
    title: 'Explain a concept',
    prompt:
      'Explain derivatives in calculus using an everyday analogy, then walk through one worked example step by step.',
  },
  {
    icon: FileEarmarkText,
    title: 'Summarize a PDF',
    prompt:
      'I will attach a PDF. Please summarize the key points and list 5 discussion questions for students.',
  },
];

function greetingForNow() {
  const hour = new Date().getHours();
  if (hour < 12) return 'Good morning';
  if (hour < 18) return 'Good afternoon';
  return 'Good evening';
}

export default function EmptyState({ firstName, onSuggestion }) {
  const name = firstName || 'there';
  return (
    <div className="mx-auto flex h-full w-full max-w-chat flex-col items-center justify-center px-4 py-10">
      <div className="mb-2 flex h-14 w-14 items-center justify-center rounded-2xl bg-accent text-lg font-bold text-white shadow-composer">
        SC
      </div>
      <h1 className="mt-4 text-center text-2xl font-semibold text-text-primary sm:text-3xl">
        {greetingForNow()}, {name}
      </h1>
      <p className="mt-2 max-w-md text-center text-sm text-text-muted">
        Your AI teaching assistant — ask anything, attach a document, or try a suggestion below.
      </p>
      <div className="mt-8 grid w-full grid-cols-1 gap-3 sm:grid-cols-2">
        {SUGGESTIONS.map((s) => {
          const Icon = s.icon;
          return (
            <button
              key={s.title}
              type="button"
              onClick={() => onSuggestion(s.prompt)}
              className="flex items-start gap-3 rounded-2xl border border-border-subtle bg-surface/40 px-4 py-3.5 text-left transition hover:border-accent/50 hover:bg-surface-hover"
            >
              <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-surface-elevated text-accent">
                <Icon size={16} />
              </span>
              <span>
                <span className="block text-sm font-medium text-text-primary">{s.title}</span>
                <span className="mt-0.5 block text-xs leading-snug text-text-muted line-clamp-2">
                  {s.prompt.slice(0, 80)}…
                </span>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
